module.exports = "/_next/static/images/humburger-steak-2e3a10e3e69f9e902c5ea8f1ce889991.jpg";